import {CommonApi} from '../request/common_api'
import store from '../store'

function productList () {
  // 产品列表
  // if (store.state.productList.length) {
  //   return
  // }
  CommonApi.getCommonTableList('000', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setProductList', res.BizBodyMsg.codeList)
    }
  })
}

function instTypeList () {
  // 机构类型列表
  CommonApi.getCommonTableList('001', {}).then(res => {
    if (res.retCode === '0000') {
      // console.log(res.BizBodyMsg.codeList)
      // store.commit('setDictTypeList', res.BizBodyMsg.codeList)
    }
  })
}

async function dictTypeList () {
  // 所有字典类型列表
  await CommonApi.getCommonTableList('002', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setDictTypeList', res.BizBodyMsg.codeList)
    }
  })
}

function mtDictTypeList () {
  // 可维护字典类型列表
  CommonApi.getCommonTableList('002', {type: '1'}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setMtDictTypeList', res.BizBodyMsg.codeList)
    }
  })
}

function deviceFactoryList () {
  // 设备厂商列表
  CommonApi.getCommonTableList('004', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setDeviceFactoryList', res.BizBodyMsg.codeList)
    }
  })
}

function factoryProductList (id = '') {
  // 厂商产品列表
  let data = {factoryid: id}
  CommonApi.getCommonTableList('005', data).then(res => {
    if (res.retCode === '0000') {
      store.commit('setFactoryProductList', res.BizBodyMsg.codeList)
    }
  })
}

function productModelList (id = '') {
  // 产品型号列表
  let data = {productid: id}
  CommonApi.getCommonTableList('005', data).then(res => {
    if (res.retCode === '0000') {
      store.commit('setProductModelList', res.BizBodyMsg.codeList)
    }
  })
}

function deviceSorts () {
  // 设备列表
  let data = {status: 'F'}
  CommonApi.getCommonTableList('007', data).then(res => {
    if (res.retCode === '0000') {
      store.commit('setDeviceSorts', res.BizBodyMsg.codeList)
    }
  })
}

function merchantList () {
  // 商户列表下拉框
  if (store.state.merchantList.length) {
    return
  }
  CommonApi.getCommonTableList('008', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setMerchantList', res.BizBodyMsg.codeList)
    }
  })
}

function licenseList () {
  // license列表下拉框
  // if (store.state.licenseList.length) {
  //   return
  // }
  CommonApi.getCommonTableList('010', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('setLicenseList', res.BizBodyMsg.codeList)
    }
  })
}

function personnelSorts () {
  // 人员类别下拉框
  if (store.state.personnelSorts.length) {
    return
  }
  CommonApi.getTableList('PERSONNELSORTS', '1').then(res => {
    if (res.retCode === '0000') {
      store.commit('setPersonnelSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function personnelPostSorts () {
  // 人员职务下拉框
  if (store.state.personnelPostSorts.length) {
    return
  }
  CommonApi.getTableList('PERSONNELPOST', '1').then(res => {
    if (res.retCode === '0000') {
      store.commit('setPersonnelPostSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function basicDataStatusSorts () {
  // 基本数据状态下拉框
  if (store.state.basicDataStatusSorts.length) {
    return
  }
  CommonApi.getTableList('BASICDATASTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('setBasicDataStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function merchantTypeSorts () {
  // 商户类型下拉框
  if (store.state.consume.merchantTypeSorts.length) {
    return
  }
  CommonApi.getTableList('MERCHANTTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setMerchantTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function terminalTypeSorts () {
  // 终端类型下拉框
  if (store.state.consume.terminalTypeSorts.length) {
    return
  }
  CommonApi.getTableList('TERMINALTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setTerminalTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function benefitsTypeSorts () {
  // 福利类型下拉框
  if (store.state.consume.benefitsTypeSorts.length) {
    return
  }
  CommonApi.getTableList('BENEFITSTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setBenefitsTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function dislimitTypeSorts () {
  // 优惠限制类型下拉框
  if (store.state.consume.dislimitTypeSorts.length) {
    return
  }
  CommonApi.getTableList('DISLIMITTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setDisLimitTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function personnelGroupSorts () {
  // 人员分组下拉框
  if (store.state.consume.personnelGroupSorts.length) {
    return
  }
  CommonApi.getTableList('PERSONNELGROUP').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setPersonnelGroupSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function accountTypeSorts () {
  // 帐户类型下拉框
  if (store.state.consume.accountTypeSorts.length) {
    return
  }
  CommonApi.getTableList('ACCTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setAccountTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function peronAccountStatusSorts () {
  // 帐户状态下拉框
  if (store.state.consume.peronAccountStatusSorts.length) {
    return
  }
  CommonApi.getTableList('PERACCSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setPeronAccountStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function accountDirectionSorts () {
  // 记帐方向下拉框
  if (store.state.consume.accountDirectionSorts.length) {
    return
  }
  CommonApi.getTableList('ACCDIRECTION').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setAccountDirectionSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function exceptionalTypeSorts () {
  // 异常类型下拉框
  if (store.state.consume.exceptionalTypeSorts.length) {
    return
  }
  CommonApi.getTableList('EXCEPTIONALTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setExceptionalTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function exceptionalProcFlagSorts () {
  // 异常处理标志下拉框
  if (store.state.consume.exceptionalProcFlagSorts.length) {
    return
  }
  CommonApi.getTableList('EXCEPPROCFLAG').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setExceptionalProcFlagSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

async function tranTypeSorts () {
  // 交易类型下拉框
  if (store.state.consume.tranTypeSorts.length) {
    return
  }
  await CommonApi.getTableList('TRANTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setTranTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function paymentTypeSorts () {
  // 缴费状态下拉框
  if (store.state.paymentTypeSorts.length) {
    return
  }
  CommonApi.getTableList('CHARGEITEMTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('setPaymentTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function batchStatusSorts () {
  // 批次状态下拉框
  if (store.state.batchStatusSorts.length) {
    return
  }
  CommonApi.getTableList('BATCHRECHARGE').then(res => {
    if (res.retCode === '0000') {
      store.commit('setBatchStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function orderFoodPeriodTypeSorts () {
  // 订餐期长下拉框
  if (store.state.orderFoodPeriodTypeSorts.length) {
    return
  }
  CommonApi.getTableList('ORDERFOODPERIODTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('setOrderFoodPeriodTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

const getCommDropDownList = {
  batchStatusSorts,
  deviceSorts,
  paymentTypeSorts,
  merchantTypeSorts,
  terminalTypeSorts,
  benefitsTypeSorts,
  dislimitTypeSorts,
  personnelGroupSorts,
  accountTypeSorts,
  peronAccountStatusSorts,
  accountDirectionSorts,
  exceptionalTypeSorts,
  exceptionalProcFlagSorts,
  tranTypeSorts,
  personnelSorts,
  personnelPostSorts,
  basicDataStatusSorts,
  merchantList,
  dictTypeList,
  deviceFactoryList,
  factoryProductList,
  productModelList,
  orderFoodPeriodTypeSorts,
  instTypeList,
  productList,
  licenseList,
  mtDictTypeList
}

export {getCommDropDownList}



// WEBPACK FOOTER //
// ./src/util/CommDropDownList.js